const L = {
  name: "Malta",
  dimensions: { width: 24, height: 24 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 24 24" style="enable-background:new 0 0 24 24;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M9.4,0h-4L10,10L0,5.4v4L2.6,12L0,14.6v4L10,14L5.4,24h4l2.6-2.6l2.6,2.6h4L14,14l10,4.5v-4L21.4,12L24,9.4
			v-4L14,10l4.5-10h-4L12,2.6L9.4,0z M12,14.4l3.4,7.6h0L12,18.6L8.6,22h0L12,14.4z M12,9.6L8.6,2h0L12,5.4L15.4,2h0L12,9.6z
			 M14.4,12L22,8.6v0L18.6,12l3.4,3.4v0L14.4,12z M2,8.6L9.6,12L2,15.4v0L5.4,12L2,8.6L2,8.6z"/>
	</g>
</g>
</svg>
  `
};
export {
  L as Malta
};
